import { GoogleGenAI } from '@google/genai'

const API_KEY = process.env.GEMINI_API_KEY || 'AIzaSyDBD7behhp9LVD2vuoSuzDhn3i4R2vohgI'

/**
 * Servicio centralizado para interacción con Google Generative AI
 */
export class AiService {
  constructor(apiKey = API_KEY) {
    this.ai = new GoogleGenAI({ apiKey })
    this.chats = new Map()
    this.chatKeys = new Map() // Cache de keys
  }

  /**
   * Cachea y retorna la key del chat
   */
  getChatKey(model, prompt) {
    const tempKey = `${model}-${prompt.slice(0, 20)}`
    if (!this.chatKeys.has(tempKey)) {
      this.chatKeys.set(tempKey, `${model}-${prompt.slice(0, 50)}`)
    }
    return this.chatKeys.get(tempKey)
  }

  /**
   * Obtiene o crea un chat con el modelo y prompt especificados
   * @param {string} model - Modelo de IA a usar
   * @param {string} prompt - System instruction
   * @param {number} thinkingBudget - Budget de thinking (0, -1, o número)
   */
  getChat(model, prompt, thinkingBudget = -1) {
    const key = this.getChatKey(model, prompt)

    if (!this.chats.has(key)) {
      const config = {
        systemInstruction: prompt
      }

      // Solo agregar thinkingConfig para modelos 2.5
      if (model.includes('2.5')) {
        config.thinkingConfig = {
          thinkingBudget: thinkingBudget
        }
      }

      this.chats.set(
        key,
        this.ai.chats.create({
          model: model,
          config
        })
      )
    }

    return this.chats.get(key)
  }

  /**
   * Envía un mensaje al chat especificado
   */
  async sendMessage(model, prompt, message, thinkingBudget = -1) {
    const chat = this.getChat(model, prompt, thinkingBudget)
    const response = await chat.sendMessage({ message })

    return {
      text: response.text,
      usageMetadata: response.usageMetadata
    }
  }

  /**
   * Resetea un chat específico o todos
   */
  resetChat(model = null, prompt = null) {
    if (model && prompt) {
      const key = this.getChatKey(model, prompt)
      this.chats.delete(key)
      this.chatKeys.delete(`${model}-${prompt.slice(0, 20)}`)
    } else {
      this.chats.clear()
      this.chatKeys.clear()
    }
  }
}

export default AiService
